export default __webpack_public_path__ + "static/media/Events.caf89596.svg";